import { IconButton, styled } from '@mui/material'
import { alpha, darken } from '@mui/material/styles'
import { FAIRTRADE_FONT_STACK } from '../constants'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

const DEFAULT_BACKGROUND = '#D4FF47'
const DEFAULT_TEXT = '#111111'

const getTopPosition = (isTopDivider?: boolean, isImpactPage?: boolean, topOffset = 0) => {
  const base = !isTopDivider && isImpactPage ? 5 : 20
  return `${base + topOffset}px`
}

const isCustomNavProp = (prop: string) =>
  prop === 'absolute' ||
  prop === 'isImpactPage' ||
  prop === 'isTopDivider' ||
  prop === 'topOffset' ||
  prop === 'backgroundColor' ||
  prop === 'textColor'

export const FairtradeLeftButton = styled(IconButton, {
  shouldForwardProp: (prop) => !isCustomNavProp(prop as string),
}) <{
  absolute?: boolean
  isImpactPage?: boolean
  isTopDivider?: boolean
  topOffset?: number
  backgroundColor?: string
  textColor?: string
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(1)};
  position: ${({ absolute }) => (absolute ? 'absolute' : 'static')};
  top: ${({ isTopDivider, isImpactPage, topOffset }) =>
    getTopPosition(isTopDivider, isImpactPage, topOffset)};
  left: 20px;
  z-index: 99999;

  border-radius: 0px;
  background-color: ${({ backgroundColor }) => backgroundColor || DEFAULT_BACKGROUND};
  padding: ${({ theme }) => `${theme.spacing(1.25)} ${theme.spacing(2)}`};
  color: ${({ textColor }) => textColor || DEFAULT_TEXT};
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
  font-family: ${FAIRTRADE_FONT_STACK};
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background-color: ${({ backgroundColor }) =>
    backgroundColor ? darken(backgroundColor, 0.05) : darken(DEFAULT_BACKGROUND, 0.05)};
    box-shadow: 0px 10px 24px ${({ backgroundColor }) => alpha(backgroundColor || DEFAULT_TEXT, 0.2)};
  }
  font-weight: 600;
  font-size: 16px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(1.25)}`};
    gap: ${({ theme }) => theme.spacing(0.5)};
    font-size: 14px;
  }
`

export const FairtradeRightButton = styled(IconButton, {
  shouldForwardProp: (prop) => !isCustomNavProp(prop as string),
}) <{
  isImpactPage?: boolean
  isTopDivider?: boolean
  topOffset?: number
  backgroundColor?: string
  textColor?: string
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(1)};
  position: absolute;
  top: ${({ isTopDivider, isImpactPage, topOffset }) =>
    getTopPosition(isTopDivider, isImpactPage, topOffset)};
  right: 20px;
  z-index: 99999;

  border-radius: 0px;
  background-color: ${({ backgroundColor }) => backgroundColor || DEFAULT_BACKGROUND};
  padding: ${({ theme }) => `${theme.spacing(1.25)} ${theme.spacing(2)}`};
  color: ${({ textColor }) => textColor || DEFAULT_TEXT};
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
  font-family: ${FAIRTRADE_FONT_STACK};
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background-color: ${({ backgroundColor }) =>
    backgroundColor ? darken(backgroundColor, 0.05) : darken(DEFAULT_BACKGROUND, 0.05)};
    box-shadow: 0px 10px 24px ${({ backgroundColor }) => alpha(backgroundColor || DEFAULT_TEXT, 0.2)};
  }
  font-weight: 600;
  font-size: 16px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(1.25)}`};
    gap: ${({ theme }) => theme.spacing(0.5)};
    font-size: 14px;
  }
`

export const FairtradeNavLabel = styled('span')`
  letter-spacing: 0.02em;
  text-align: center;
  line-height: 1.1;
  max-width: 160px;
  white-space: normal;
  font-family: ${FAIRTRADE_FONT_STACK};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    max-width: 100px;
  }
`

export const FairtradeNextPageIcon = styled(ArrowForwardIcon)`
  width: 20px;
  height: 20px;
  color: currentColor;
`

export const FairtradePrevPageIcon = styled(ArrowBackIcon)`
  width: 20px;
  height: 20px;
  color: currentColor;
`

